var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{ref:"search",staticClass:"search-input search-toggle",class:{
    open: _vm.alwaysOpen || _vm.searchOpen,
    large: _vm.large,
    'background-dark': _vm.dark,
  },attrs:{"prepend-icon":"search","value":_vm.value,"placeholder":_vm.placeholder,"clear-icon":"cancel","clearable":"","autocomplete":false,"autofocus":_vm.autofocus},on:{"input":_vm.handleSearch,"click:prepend":_vm.toggleActive,"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('submit')},"click:clear":function($event){return _vm.$emit('cleared')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }